var _a;
export var ROUTE_404 = '/404';
export var ROUTE_SEARCH = '/search(/:query)';
export var ROUTE_LOGIN = '/login';
export var ROUTE_ACCOUNT_SUSPENDED = '/account-suspended';
export var ROUTE_CREATE_POST = '/create-post';
export var ROUTE_CREATE_QUESTION = '/create-question';
export var ROUTE_COMMENT_DEEP_LINK = '/main/comment/:commentId';
export var ROUTE_CATEGORY = '/:categorySlug(/p-:page)';
export var ROUTE_CATEGORY_CREATE_POST = '/:categorySlug/create-post';
export var ROUTE_CATEGORY_CREATE_QUESTION = '/:categorySlug/create-question';
export var ROUTE_POST = '/:categorySlug/:postSlug(/p-:commentsPage)(/dl-:deepLinkData)';
export var ROUTE_POST_EDIT = '/:categorySlug/:postSlug/edit';
export var ROUTE_HOME = '/(p-:page)';
export var ROUTE_DEV_PLAYGROUND = '/dev-playground';
export var ALL_ROUTES = (_a = {},
    _a[ROUTE_404] = ROUTE_404,
    _a[ROUTE_SEARCH] = ROUTE_SEARCH,
    _a[ROUTE_LOGIN] = ROUTE_LOGIN,
    _a[ROUTE_ACCOUNT_SUSPENDED] = ROUTE_ACCOUNT_SUSPENDED,
    _a[ROUTE_CREATE_POST] = ROUTE_CREATE_POST,
    _a[ROUTE_CREATE_QUESTION] = ROUTE_CREATE_QUESTION,
    _a[ROUTE_COMMENT_DEEP_LINK] = ROUTE_COMMENT_DEEP_LINK,
    _a[ROUTE_CATEGORY] = ROUTE_CATEGORY,
    _a[ROUTE_CATEGORY_CREATE_POST] = ROUTE_CATEGORY_CREATE_POST,
    _a[ROUTE_CATEGORY_CREATE_QUESTION] = ROUTE_CATEGORY_CREATE_QUESTION,
    _a[ROUTE_POST] = ROUTE_POST,
    _a[ROUTE_POST_EDIT] = ROUTE_POST_EDIT,
    _a[ROUTE_HOME] = ROUTE_HOME,
    _a[ROUTE_DEV_PLAYGROUND] = ROUTE_DEV_PLAYGROUND,
    _a);
//# sourceMappingURL=routes.js.map